import React from 'react';
import PropTypes from 'prop-types';

/**
 * Input - A wrapper that renders a standard HTML input with Bulma class names
 * 
 * This component accepts the same props as Bloomer Input for easy migration
 */
const Input = ({
  className = '',
  style = {},
  type = 'text',
  isSize = null,
  isColor = null,
  isRounded = false,
  isStatic = false,
  isLoading = false,
  readOnly = false,
  disabled = false,
  placeholder = '',
  value = '',
  onChange = () => {},
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['input'];
    
    // Add appropriate classes based on props
    if (isSize) {
      classes.push(`is-${isSize}`);
    }
    
    if (isColor) {
      classes.push(`is-${isColor}`);
    }
    
    if (isRounded) {
      classes.push('is-rounded');
    }
    
    if (isStatic) {
      classes.push('is-static');
    }
    
    if (isLoading) {
      classes.push('is-loading');
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <input 
      className={getClassNames()} 
      style={style}
      type={type || 'text'}
      readOnly={readOnly}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
};

// eslint-disable-next-line react/require-default-props
Input.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string,
  isSize: PropTypes.oneOf(['small', 'medium', 'large']),
  isColor: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
  isRounded: PropTypes.bool,
  isStatic: PropTypes.bool,
  isLoading: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func
};



export default Input;
